import { z } from 'zod';
import { DataSyncTypeSchema } from '../inputTypeSchemas/DataSyncTypeSchema'
import { DataSyncExternalRecordTypeSchema } from '../inputTypeSchemas/DataSyncExternalRecordTypeSchema'

/////////////////////////////////////////
// CORE INTEGRATION DATA SYNC MAPPING SCHEMA
/////////////////////////////////////////

export const CoreIntegrationDataSyncMappingSchema = z.object({
  syncType: DataSyncTypeSchema,
  externalRecordType: DataSyncExternalRecordTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  integrationId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  gogovFieldName: z.string().nullable(),
  gogovFieldId: z.bigint().nullable(),
  externalFieldName: z.string().nullable(),
  externalFieldId: z.string().nullable(),
  mergeField: z.string().nullable(),
})

export type CoreIntegrationDataSyncMapping = z.infer<typeof CoreIntegrationDataSyncMappingSchema>

export default CoreIntegrationDataSyncMappingSchema;
